function loadLanguagesforCountry(e) {
    const target = 'target' in e ? $(e.target) : e;
    const countrySelected = target.find('option:selected');
    const toggleElements = $('.cover:eq(1), #language, .select-icon:eq(1)');
    const prehomeButton = $('#preHome .prehomebutton');

    if (countrySelected.attr('data-external-redirect')) {
        toggleElements.hide();
    } else {
        toggleElements.show();
    }
    $('.message-error').hide();
    const urli = target.attr('data-url');
    const datAjax = {
        format: 'ajax',
        locale: countrySelected.attr('data-locale'),
        countryCode: countrySelected.attr('data-country-code'),
        countryselect: true,
        action: prehomeButton.attr('data-action'),
        querystring: prehomeButton.attr('data-querystring'),
        countryAndState: countrySelected.attr('data-countryAndState'),
    };

    return {
        urli,
        datAjax,
    };
}

function myAjax(myResponse, pushState) {
    const preHomeButton = $('.prehomebutton');
    const languageSelector = $('#preHome #language');

    if (pushState) {
        languageSelector.html(myResponse.html);
    }

    $('.title-container').find('span').text(myResponse.prehomeTitle);
    preHomeButton.attr('data-url', myResponse.url);

    preHomeButton.val(myResponse.prehomeAccept);
    preHomeButton.find('span').text(myResponse.prehomeAccept);
}

const updateGeolocationButtonData = (e) => {
    const result = loadLanguagesforCountry(e);
    $.ajax({
        url: result.urli,
        data: result.datAjax,
        method: 'GET',
    }).done((response) => {
        myAjax(response, true);
    });
};

const showPrehome = (prehomeModal) => {
    if (prehomeModal.hasClass('cta-bar-container')) {
        prehomeModal.show();
    } else {
        prehomeModal.modal();
    }
};

function updateCountryLocale(urlCountryLocale, locale, countryCode, urlReturn) {
    const prehomeButton = $('#preHome .prehomebutton');
    const countrySelected = $('#countrySite option:selected');

    const datAjax = {
        locale,
        countryCode,
        action: prehomeButton.data('action'),
        querystring: prehomeButton.data('querystring'),
        countryAndState: countrySelected.attr('data-countryAndState'),
    };

    $.ajax({
        url: urlCountryLocale,
        data: datAjax,
        method: 'GET',
    }).done(() => {
        window.location.href = urlReturn;
    });
}

const preHomeModalCode = () => {
    const prehomeModal = $('#preHome');

    if (prehomeModal.length && prehomeModal.hasClass('preHomeActive')) {
        const $countrySelectedParent = $('#countrySiteFooter option:selected').parent();
        showPrehome(prehomeModal);
        updateGeolocationButtonData($countrySelectedParent);
    }
};

const footerSelectorEvents = () => {
    const languageSelector = $('#languageFooter');
    const countrySelector = $('#countrySiteFooter');

    countrySelector.on('change', (e) => {
        const prehomeModal = $('#preHome');
        const countrySelected = $('#countrySiteFooter option:selected');

        if (prehomeModal.length) {
            const countryModal = prehomeModal.find('#countrySite');
            const result = loadLanguagesforCountry(e);

            showPrehome(prehomeModal);
            countryModal.val(countrySelected.data('country-code'));

            $('#countrySite option').removeAttr('selected');
            $(`#countrySite option[data-countryandstate='${countrySelected.attr('data-countryandstate')}']`).attr('selected', 'selected');

            $.ajax({
                url: result.urli,
                data: result.datAjax,
                method: 'GET',
            }).done((response) => {
                myAjax(response, true);
            });
        }
    });

    languageSelector.on('change', (e) => {
        const url = $(e.target).find('option:selected').data('url');
        if (url) {
            const countrySelected = $('#countrySiteFooter option:selected');
            const localeSelected = $(e.target).find('option:selected').val();
            updateCountryLocale(
                $('#countrySiteFooter').data('urlcountry'),
                localeSelected,
                countrySelected.attr('data-country-code'),
                url,
            );
        }
    });
};

const modalSelectorEvents = () => {
    const languageSelector = $('#preHome #language');
    const countrySelector = $('#countrySite');

    countrySelector.on('change', (e) => {
        updateGeolocationButtonData(e);
    });

    languageSelector.on('change', (e) => {
        const prehomeButton = $('.prehomebutton');
        if (prehomeButton.length) {
            const languageSelected = $('#language option:selected').val();
            const countrySelected = $('#countrySite option:selected');
            const urli = $('#countrySite').data('url');
            const datAjax = {
                format: 'ajax',
                locale: languageSelected,
                countryCode: countrySelected.data('country-code'),
                countryselect: true,
                action: prehomeButton.data('action'),
                querystring: prehomeButton.data('querystring'),
                countryAndState: countrySelected.attr('data-countryAndState'),
            };

            prehomeButton.data(
                'url',
                $(e.target).find('option:selected').data('url'),
            );

            $.ajax({
                url: urli,
                data: datAjax,
                method: 'GET',
            }).done((response) => {
                myAjax(response, false);
            });
        } else {
            const languageSelected = $('#language option:selected');
            updateCountryLocale(
                $('#countrySiteFooter').data('urlcountry'),
                languageSelected.val(),
                languageSelected.attr('data-country-code'),
                $('#language option:selected').data('url'),
            );
        }
    });

    $('.prehomebutton').on('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const externalRedirection = $('#countrySite option:selected').data(
            'external-redirect',
        );
        const thisTarget = $(e.currentTarget);
        if (externalRedirection) {
            window.location.href = externalRedirection;
        } else {
            const url = !$('.prehomebutton').attr('data-url') ? $('#countrySite option:selected').data('url') : $('.prehomebutton').attr('data-url');

            if (url !== undefined) {
                const modal = thisTarget.closest('#preHome');

                updateCountryLocale(
                    $('#countrySite').data('urlcountry'),
                    modal.find('#language option:selected').val() || modal.find('#countrySite option:selected').attr('data-locale'),
                    $('#countrySite option:selected').attr('data-country-code'),
                    url,
                );
            } else {
                window.location.reload();
            }
        }
    });

    $('#preHome').on('click', '.icon-cross-line', () => {
        $('#preHome').hide();
    });
};

module.exports = {
    methods: {
        preHomeModalCode: preHomeModalCode,
        footerSelectorEvents: footerSelectorEvents,
        modalSelectorEvents: modalSelectorEvents,
        myAjax: myAjax,
        loadLanguagesforCountry: loadLanguagesforCountry,
        updateCountryLocale: updateCountryLocale,
    },
    initialLoad() {
        jQuery(() => {
            if ($('#countrySite option:selected').data('external-redirect')) {
                $('.cover:eq(1)').hide();
                $('#language').hide();
                $('.select-icon:eq(1)').hide();
            }
        });
    },
    loadSelector() {
        preHomeModalCode();
        footerSelectorEvents();
        modalSelectorEvents();
    },
};
